import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";

/**
 * Rozšířené informace o LOV atributu.
 */
export interface IDataSourceLOVAttribute extends IDataSourceAttribute {
    /** Atributy zobrazené v jedné buňce (například u LOVAttribute).*/
    showAttrs: string[];
    /** Název formuláře k otevření (například u LOVAttribute). */
    editWindow?: string;
}

export class IDataSourceLOVAttribute {
    private static _properties: (keyof IDataSourceLOVAttribute)[] = ["showAttrs", "editWindow"];
    private static _interfaces = [IDataSourceAttribute];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            this._properties.every((value) => Reflect.has(instance, value)) &&
            this._interfaces.every((_interface) => instance instanceof _interface);
    }
}
